<template>
  <v-app class="bckgrnd">

    <v-card class="form-container" style="border:1px solid">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <h4 style="text-align:center;font-weight:bold;padding-bottom:25px"><span style="font-size:35px">U</span>SER&nbsp;<span style="font-size:35px">D</span>ETAILS</h4>
          </v-flex>
          <v-flex xs12 md4 sm12 style="padding-right: 5px">
            <v-text-field :readonly="edit === false" v-model="form.fullName" label="Full name" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md4 sm12 style="padding-right: 5px">
            <v-text-field :readonly="edit === false" v-model="form.mobileNumber" label="Mobile number" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md4 sm12>
            <v-text-field :readonly="edit === false" v-model="form.email" label="Email id" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md6 sm6 style="padding-right: 5px">
            <v-text-field :readonly="edit === false" v-model="form.country" label="Country" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md6 sm6>
            <v-text-field :readonly="edit === false"
             v-model="form.companyName"
             label="Company Name"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6 sm6 style="padding-right: 5px">
            <v-text-field :readonly="edit === false" v-model="form.userName" label="User name" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 md6 sm6>
            <v-text-field :readonly="edit === false"
             v-model="form.passwords" label="Password"
              :rules="emptyRule" required
              :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
              :type="passwordShow ? 'text' : 'password'"
              @click:append="passwordShow = !passwordShow"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 style="text-align:right">
            <v-btn v-if="form.isActive==false" large depressed :loading="btnSave" color="#E31E24" dark @click="onDelete(form)">Approve</v-btn>
            <v-btn v-if="form.isActive==true" large depressed :loading="btnSave" color="#E31E24" dark @click="onDelete(form)">Deactive</v-btn>
            <v-btn large depressed color="primary" dark @click="back()">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "Edit user",
      edit: false,
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      passwordShow: false,

      emptyRule: [v => !!v || "Input is required"],
      valid: true,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Counsellor",
          disabled: false,
          to: "/users"
        },
        {
          text: "Edit counsellor",
          disabled: true,
          to: "/editUser"
        }
      ],

      form: null
    };
  },

  mounted() {

      this.axios
      .get(config.API + `Admin/${this.$route.params.id}`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.form = res.data;
      });
    },
    

  methods: {
    back() {
      this.$router.go(-1);
    },

    onDelete(form) {
      if (confirm("You want to update !!")) {
        this.btnSave = true;
        this.axios
          .delete(config.API + `Admin/${form.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Successfully updated");
            this.$router.go(-1);
            this.btnSave = false;
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      }
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .put(
            config.API + `Admin/${this.$route.params.id}`,
            {
              id: this.$route.params.id,
              userName: this.form.userName,
              fullName: this.form.fullName,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              address: this.form.address,
              email: this.form.email
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("User updated successful");
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
.bckgrnd {
  background-image: linear-gradient(-180deg, #eeeeee, #bdbdbd) !important;
  background-size:cover !important;
}
</style>
